


















import {
  defineComponent
} from '@nuxtjs/composition-api';
import { useUser } from '@wemade-vsf/customer';
import userGetters from '@wemade-vsf/customer/lib/runtime/getters/userGetters';

export default defineComponent({
  name: 'ProfileDetails',
  setup () {
    const { user } = useUser();
    const userData = user.value ? {
      email: userGetters.getEmailAddress(user.value),
      firstname: userGetters.getFirstName(user.value),
      lastname: userGetters.getLastName(user.value)
    } : {
      email: '',
      firstname: '',
      lastnme: ''
    }

    return {
      userData
    }
  }
})
